// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3kd0I","header":"ReportDetails_header__1hCVS","title":"ReportDetails_title__rsPHN","left":"ReportDetails_left__3tJVp"};